<template>
  <div>
    <el-image
      style="width: 100%;min-width:1000px"
      src="../assets/img/bg_01.jpg"
      fit="fit"></el-image>
    <div class="rotatingImg">
      <img class="rotationBg" src="../assets/img/bg_02.jpg">
      <img class="rotation" src="../assets/img/zhizhen.png">
    </div>
    <div class="inputBg">
      <div class="inputStock">
        <el-row>
          <el-col :span="12">
            <el-select v-model="state" filterable remote :remote-method="remoteMethod" :loading="loading"
                       @change="openDetailed" placeholder="代码/名称/简拼" size="medium" class="full_width">
              <el-option
                v-for="item in options"
                :key="item.short"
                :label="item.name +' '+item.short"
                :value="item.short">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <a href="javascript:void(0);" @click="getStockInfo">
              <img src="../assets/img/button01.png" class="getStockInfo">
            </a>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="zhengu2">
      <img src="../assets/img/bg_04.jpg" style="width: 100%;">
      <img src="../assets/img/bg_05.jpg" style="width: 100%">
      <img src="../assets/img/bg_06.jpg" style="width: 100%">
      <div class="btnZhengu">
        <el-select v-model="state" filterable remote :remote-method="remoteMethod" :loading="loading"
                   @change="openDetailed" placeholder="代码/名称/简拼" size="medium" class="full_width">
          <el-option
            v-for="item in options"
            :key="item.short"
            :label="item.name +' '+item.short"
            :value="item.short">
          </el-option>
        </el-select>
        <br><br>
        <a href="javascript:void(0);" @click="getStockInfo">
          <img src="../assets/img/button01.png" class="getStockInfo">
        </a>
      </div>
    </div>
    <el-dialog title="智能诊股" :visible.sync="stockInfoStatus" width="620px">
      <div class="stockInfoWrapper">
        <el-row>
          <el-col :span="12">
            <div class="stockTitle">
              <p class="tName">
                {{ stockInfo.name }}
              </p>
              <p class="tCode">
                {{ stockInfo.code }}
              </p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="stockTitle">
              <p class="tPrice" :class="activeColor">{{ stockInfo.price }}<i class="el-icon-top" v-if="activeColor==='red'"></i><i class="el-icon-bottom" v-else></i></p>
              <p class="tChange" :class="activeColor">
                {{ stockInfo.pricechange }} {{ stockInfo.changepercent }}%
              </p>
              <p class="tTime">
                {{ time }}
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                今开
              </p>
              <p>
                {{ stockInfo.open }}
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                最高
              </p>
              <p>
                {{ stockInfo.high }}
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                换手
              </p>
              <p>
                {{ stockInfo.changeHands }}%
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                成交量
              </p>
              <p>
                {{ Number(stockInfo.volume)/100 }}万
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                昨收
              </p>
              <p>
                {{ stockInfo.settlement }}
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                最低
              </p>
              <p>
                {{ stockInfo.low }}
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                振幅
              </p>
              <p>
                {{ stockInfo.amplitude }}%
              </p>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stockDynamic">
              <p>
                成交额
              </p>
              <p>
                {{ (Number(stockInfo.amount)/10000).toFixed(2) }}亿
              </p>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="stockDiagnose">
              <el-row>
                <el-col :span="8">
                  <h4 class="right">大数据透视：</h4>
                </el-col>
                <el-col :span="16">
                  <p>{{ stockInfo.statement1 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" >
                  <h4>短期阻力位：</h4>
                </el-col>
                <el-col :span="16">
                  <p>{{ stockInfo.statement2 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" >
                  <h4>技术支撑位：</h4>
                </el-col>
                <el-col :span="16">
                  <p>{{ stockInfo.statement3 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" >
                  <h4>主力动态：</h4>
                </el-col>
                <el-col :span="16">
                  <p>{{ stockInfo.statement4 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8" >
                  <h4>中期趋势：</h4>
                </el-col>
                <el-col :span="16">
                  <p>{{ stockInfo.statement5 }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <h4>业绩成长：</h4>
                </el-col>
                <el-col :span="16">
                  <p>{{ stockInfo.statement6 }}</p>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <p class="control">{{ stockInfo.major_control }}</p>
            <div class="kptype" :class="activeClass">

            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="stockInfoStatus = false">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
  import $ from "jquery";
  import eventBus from "../assets/js/eventBus";

  export default {
    name: "diagnosisStock",
    data() {
      return {
        time:'',
        code: '',
        loading: false,
        state: '',   //模糊搜索
        options: [],
        stockInfoStatus: false,
        stockInfo:{
          //股票名
          name:'',
          //股票代码
          code:'',
          //价格
          price:'',
          //今开
          open:'',
          //最高
          high:'',
          //换手率
          changeHands:'',
          //成交量
          volume:'',
          //昨收
          settlement:'',
          //最低
          low:'',
          //振幅
          amplitude:'',
          //成交额
          amount:'',
          //涨跌额
          pricechange:'',
          //涨跌幅
          changepercent:'',
          //大数据透视
          statement1:'',
          //短期阻力位
          statement2:'',
          //技术支撑位
          statement3:'',
          //主力动态
          statement4:'',
          //中期趋势
          statement5:'',
          //业绩成长
          statement6:'',
          zlzc:'',
          major_control:'',
          chipPoint:'',
        },
        activeClass: 'none',
        activeColor: 'red'
      }
    },
    methods: {
      remoteMethod(query) {
        let that = this;
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options = that.restaurants.filter(item => {
              return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options = [];
        }
      },
      getTime() {
        let that = this;
        this.timer = setInterval(function () {
           const deviceTz = that.$moment.tz.guess();            
          that.time = that.$moment().tz(deviceTz).format("YYYY-MM-DD HH:mm:ss");
        },1000)
      },
      openDetailed() {
        let that = this;

      },
      loadAll() {
        let that = this;
        that
          .$http({
            url: "/",             //请求地址
            method: "post",
            data: {
              'nozzle': 'all_stock',
            }
          })
          .then(ret => {
            let resData = ret.data;
            if (resData.code === 1) {
              for (let i = 0, len = resData.data.length; i < len; i++) {
                resData.data[i].value = resData.data[i].short + ' ' + resData.data[i].name + ' ' + resData.data[i].pinyin;
              }
              that.restaurants = resData.data;
            } else {
              that.$alert('请稍后尝试', '提示', {
                confirmButtonText: '确定',
                callback: action => that.loadAll()
              })
            }
          });
      },
      getStockInfo() {
        let that = this;
        let stockCode = that.state;
        if (stockCode === '') {
          this.$message.error('请输入股票代码');
          return false;
        }


        let url = "https://finance.sina.com.cn/tzy/diagnose/" + stockCode + "/app_public.js";
        $.ajax({
          url: url,
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            that.stockInfo.statement1 = diagnose.statement1;
            that.stockInfo.statement2 = diagnose.statement2;
            that.stockInfo.statement3 = diagnose.statement3;
            that.stockInfo.statement4 = diagnose.statement4;
            that.stockInfo.statement5 = diagnose.statement5;
            that.stockInfo.statement6 = diagnose.statement6;
            that.stockInfo.major_control = diagnose.major_control;
            // that.stockInfo.point_ratio = diagnose.point_ratio;
            that.stockInfo.chipPoint = tech.chipPoint;
            that.stockInfo.zlzc = tech.zlzc;
            that.activeClass = that.zlkp(diagnose.point_ratio)
          }
        });
        that.getNewPrice(stockCode);
        that.stockInfoStatus = true;
        clearInterval(that.chatTimer);
        this.chatTimer = setInterval(function () {
          that.getNewPrice(stockCode);
        },1000);

      },

      getNewPrice(stockCode){
        let that = this;
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + stockCode,
          type: "GET",
          dataType: "script",
          cache: true,
          success: function() {
            var elements = eval("v_" + stockCode).split("~");
            that.stockInfo.name = elements[1];
            that.stockInfo.code = stockCode;
            that.stockInfo.price = elements[3];
            that.stockInfo.open = elements[5];
            that.stockInfo.pricechange = elements[31];
            if (elements[31].substr(0,1) === '-'){
              that.activeColor = 'green';
            }else{
              that.activeColor = 'red';
            }
            that.stockInfo.changepercent = elements[32];
            that.stockInfo.high = elements[33];
            that.stockInfo.changeHands = elements[38];
            that.stockInfo.volume = elements[36];
            that.stockInfo.settlement = elements[4];
            that.stockInfo.low = elements[34];
            that.stockInfo.amplitude = elements[43];
            that.stockInfo.amount = elements[37];
          }
        });
      },

      zlw(point) {
        if (point < 0) {
          return 'dp';
        } else if (point >= 0 && point <= 30) {
          return 'dp';
        } else if (point > 30 && point <= 64.48) {
          return 'qzc';
        } else if (point > 64.48 && point <= 141.24) {
          return 'zd';
        } else if (point > 141.24 && point <= 210) {
          return 'qzl';
        } else if (point > 210 && point <= 240) {
          return 'tp';
        } else {
          return 'tp';
        }
      },
      zlkp(point) {
        if (point < 20) {
          return 'none';
        } else if (point >= 20 && point < 60) {
          return 'qing';
        } else if (point >= 60 && point < 120) {
          return 'zhong';
        } else {
          return 'gao';
        }
      }
    },
    mounted: function () {
      let that = this;
      that.loadAll();
      that.getTime();
    },
    beforeDestroy(){
      clearInterval(this.timer);
      clearTimeout(this.chatTimer);
    }
  }
</script>

<style scoped>
  .rotatingImg {
    width: 100%;
    position: relative;
    min-width: 1200px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .rotationBg {
    width: 100%;
    position: relative;
    margin: 0 auto;
  }

  .rotation {
    margin: auto;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    -webkit-transform: rotate(360deg);
    animation: rotation 4s linear infinite;
    -moz-animation: rotation 4s linear infinite;
    -webkit-animation: rotation 4s linear infinite;
    -o-animation: rotation 4s linear infinite;
  }

  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  .inputBg {
    width: 100%;
    height: 120px;
    background: #ffe7db;
  }

  .inputStock {
    width: 1000px;
    min-width: 1000px;
    margin: 0 auto;
    text-align: center;
  }

  .full_width {
    width: 85%;
  }

  .full_width >>> input {
    height: 80px;
  }

  .getStockInfo {
    width: 85%;
    height: 80px;
    cursor: pointer;
    -webkit-animation: pulse2 1.1s linear infinite both;
    animation: pulse2 1.1s linear infinite both;
  }

  @keyframes pulse2 {
    0% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1)
    }

    50% {
      -webkit-transform: scale(1.05);
      -ms-transform: scale(1.05);
      transform: scale(1.05)
    }

    100% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1)
    }
  }

  .zhengu2 {
    width: 100%;
    min-width: 1000px;
    position: relative;
  }
  .zhengu2 img{
    width: 100%;
  }

  .btnZhengu {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 125px;
    margin: auto;
    text-align: center;
    width: 25%;
  }

  .stockInfoWrapper{
    width: 100%;
    height: 550px;
    text-align: center;
    background: url("../assets/img/headcolor.png") no-repeat;
  }

  .stockTitle{
    height: 140px;
  }
  .tName{
    font-size: 52px;
    font-weight: bold;
    height: 50%;
    line-height: 70px;
  }
  .tCode{
    font-size: 40px;
    height: 50%;
    line-height: 70px;
  }
  .tPrice{
    font-size: 48px;
    font-weight: bold;
    line-height: 60px;
    height: 60px;
  }

  .tChange{
    font-size: 26px;
    line-height: 40px;
    height: 40px;
  }

  .tTime{
    line-height: 40px;
    height: 40px;
    font-size: 24px;
  }
  .stockDynamic{
    height: 80px;
  }

  .stockDynamic p{
    height: 50%;
    line-height: 40px;
    font-size: 24px;
    color: #333;
  }

  .stockDiagnose{
    text-align: left;
    height: 200px;
    /*overflow: hidden;*/
    margin-top: 20px;
  }
  .stockDiagnose h4{
    padding: 5px 0;
    text-align: right;
  }
  .stockDiagnose p{
    padding: 5px 0;
  }

  .control{
    margin-top: 20px;
    text-align: left;
  }

  .kptype{
    margin-top: 30px;
    width: 256px;
    height: 146px;
  }

  .green{
    color: #008000;
  }


  .kptype.none {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -20px -20px;
  }

  .kptype.qing {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -295px -20px;
  }

  .kptype.zhong {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -20px -185px;
  }

  .kptype.gao {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_main_type.png") no-repeat -295px -185px;
  }

  .zlwtype.dp {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -20px -20px;
  }

  .zlwtype.qzc {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -306px -20px;
  }

  .zlwtype.rzc {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -592px -20px;
  }

  .zlwtype.zd {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -878px -20px;
  }

  .zlwtype.rzl {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -20px -198px;
  }

  .zlwtype.qzl {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -306px -198px;
  }

  .zlwtype.tp {
    background: url("//n.sinaimg.cn/finance/tzy/images/gpzd_support_type.png") no-repeat -592px -198px;
  }
</style>



// WEBPACK FOOTER //
// src/components/diagnosisStock.vue